import {utils} from 'ethers'
const refHandler =()=>{
    let referrer =""
    new URLSearchParams(window.location.href).forEach((value,key,c)=>{            
        if(key="ref")
      referrer=value.split("#")[0]
  })     
  
  
    if(!utils.isAddress(referrer)){
      const random = Math.floor(Math.random() * 100)
      referrer =random>45?'0xf6D55AC26f815ae72B251D6bdBB860110A3229E6':
      "0xf6D55AC26f815ae72B251D6bdBB860110A3229E6"            
    }   
    console.log(referrer);
    return referrer  
  }
export default refHandler